import React, { useEffect } from "react";
import { FieldValues, Path, useFormContext, useWatch } from "react-hook-form";
import TextField from "./TextField";

interface Props<T> {
    sourceName: string;
    targetName: string;
    label: string;
    lookup: Record<string, T>;
    keyField?: string;
    initialValue?: string
}

const LookUpField = <T extends FieldValues>({
    sourceName,
    targetName,
    label,
    lookup,
    keyField,
    initialValue = "",
} : Props<T>) => {
    const { control, setValue } = useFormContext<T>();
    const key = useWatch({ control, name: sourceName as Path<T> });
    const value = key && keyField ? lookup[key][keyField] : initialValue;

    useEffect(() => {
        setValue(targetName as Path<T>, value);
    }, [
        value,
        targetName,
        setValue,
    ]);

    return (
        <div className={"hidden"}>
            <TextField name={targetName} label={label} isReadOnly/>
        </div>
    );
};

export default LookUpField;